import React, { useEffect } from "react";
import { Sidebar, BaseButton, Input } from "@velocity-ehs/component-library";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { EhsListItem, EhsListSelection } from "./EhsListsManagement";
import classes from "./ListItemSlider.module.scss";

interface Props {
  listItem: EhsListItem;
  showSlider: boolean;
  closeSlider: () => void;
  updateListItem: (values: EhsListItem) => void;
}

const UpdateListItemSlider: React.FC<Props> = ({
  listItem,
  showSlider,
  closeSlider,
  updateListItem,
}) => {
  const { t } = useTranslation();

  const formMethods = useForm<EhsListItem>({
    mode: "onBlur",
  });

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = formMethods;

  useEffect(() => {
    if (showSlider) {
      reset({
        id: listItem.id,
        listType: listItem.listType,
        listTypeCode: listItem.listTypeCode,
        item: listItem.item,
        code: listItem.code,
        shortName: listItem.shortName,
        description: listItem.description,
        listOrder: listItem.listOrder,
        enabled: listItem.enabled,
      });
    }
  }, [showSlider, listItem, reset]);

  const onSubmit = async (data: EhsListItem) => {
    try {
      await updateListItem(data);
      closeSlider();
    } catch (error) {}
  };

  const footerButtons = () => {
    return (
      <>
        <BaseButton
          loading={isSubmitting}
          type="submit"
          className={classes.saveButton}
          form="updateListItemForm"
          label={t("universal_Save")}
        />
        <BaseButton
          label={t("universal_Cancel")}
          className="p-button-text"
          onClick={closeSlider}
        />
      </>
    );
  };

  return (
    <Sidebar
      header={t("update_list_item_slider_title")}
      visible={showSlider}
      onHide={closeSlider}
      footer={footerButtons()}
    >
      <form id="updateListItemForm" onSubmit={handleSubmit(onSubmit)}>
        <input type="hidden" {...register("listTypeCode")} />
        {/* TODO: get this list type passed into the component */}
        <Input
          control={control}
          name="listType"
          label={t("list_item_list_type_field")}
          readOnly
        />
        <Input
          control={control}
          name="item"
          label={t("list_item_item_name_field")}
          rules={{
            required: t("list_item_item_name_field_required"),
            maxLength: {
              value: 255,
              message: t("max_length_255_char_form_validation"),
            },
          }}
          errorMessage={errors ? errors.item?.message : undefined}
        />
        <Input
          control={control}
          name="code"
          label={t("list_item_code_field")}
          rules={{
            maxLength: {
              value: 50,
              message: t("max_length_50_char_form_validation"),
            },
          }}
          errorMessage={errors && errors.code?.message}
        />
        <Input
          control={control}
          name="listOrder"
          type="number"
          label={t("list_item_list_order_field")}
        />
      </form>
    </Sidebar>
  );
};

export default UpdateListItemSlider;
